// @ts-nocheck
import { Plus, Workflow } from 'lucide-react';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';
import { c, Section, Field, useStudio } from './ui';

const { CONVERSATIONAL_FLOW_MAX } = AI_AGENT_FIELD_LIMITS;

export default function FlowNotesSection({ value, onChange, defaultValue = '' }) {
  const { flowGenerated, readOnly, goTo } = useStudio();
  return (
    <Section
      id="flow"
      icon={Workflow}
      title="Conversation flow"
      sub="A step-by-step outline of how a call should go."
      tag={flowGenerated ? 'done' : 'required'}
      plainReq
      ok={!!flowGenerated}
    >
      <Field
        label="Description"
        htmlFor="ags-conv"
        count={(value || '').length}
        max={CONVERSATIONAL_FLOW_MAX}
        note="Example: greet, verify the order ID, look up its status."
      >
        <textarea
          id="ags-conv"
          className={c('ctl')}
          rows={5}
          maxLength={CONVERSATIONAL_FLOW_MAX}
          value={value || ''}
          placeholder="Describe the conversation flow your agent should follow when interacting with customers."
          onChange={(e) => onChange(e.target.value)}
        />
      </Field>
      {!(value || '').trim() && defaultValue && (
        <div className={c('form-card')}>
          <div className={c('fh')}>
            <Workflow className="ags-i" /> Default conversation flow
          </div>
          <p className={c('note')} style={{ margin: '0 0 10px' }}>
            You have not written your own flow, so this default is used to build the flow chart. It fills the box above once the flow chart is generated.
          </p>
          <div className={c('item')}>
            <span className={c('cb')}>
              <Workflow className="ags-i" />
            </span>
            <div style={{ minWidth: 0 }}>
              <p style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap', margin: 0 }}>{defaultValue}</p>
            </div>
            {!readOnly && (
              <div className={c('acts')}>
                <button type="button" className={c('btn small')} onClick={() => onChange(defaultValue)}>
                  <Plus className="ags-i" />
                  Use as my flow
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {!flowGenerated && !readOnly && (
        <div className={c('note')} style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <span>This step is done once the flow chart is generated. You need it before you can publish.</span>
          <button type="button" className={c('btn small')} onClick={() => goTo('flow')}>
            Go to flow chart
          </button>
        </div>
      )}
    </Section>
  );
}
